//Provides translations to components

// Create a new context for the language
import { createContext } from 'react';

// Export the context
export const LanguageContext = createContext();
